import {
  RoutePoint,
  RoutePointValue,
  MapName,
  MapType
} from '../types';

import {
  MAP_NAMES,
  MAP_TYPES,
  ROUTE_AVOID_IDS
} from '../constants';

import { mapLocalStorage } from './mapStorage';

export const createRoutePoint = (value: RoutePointValue = {}): RoutePoint => ({
  id: Math.random().toString(),
  value
});

export const checkIsActiveGoogleMap = () => (
  checkIsGoogleMap(mapLocalStorage.getName())
);

export const checkIsActiveHereMap = () => (
  checkIsHereMap(mapLocalStorage.getName() ?? MAP_NAMES.here)
);

export const checkIsGoogleMap = (mapName?: MapName) => (
  mapName === MAP_NAMES.google
);

export const checkIsHereMap = (mapName?: MapName) => (
  mapName === MAP_NAMES.here
);

export const checkIsRoadmapMapType = (mapType: MapType) => (
  mapType === MAP_TYPES.ROADMAP
);

export const checkIsHybridMapType = (mapType: MapType) => (
  mapType === MAP_TYPES.HYBRID
);

export const roundRouteDistance = (routeDistance?: string | number) => Math.round(Number(routeDistance));
export const roundRoutePrice = (routePrice?: string | number) => +Number(routePrice).toFixed(2);

export const mappingRoutesAvoid = (value: { [key: string]: boolean }) => Object.keys(value).reduce((acc, key) => {
  const id = ROUTE_AVOID_IDS[key as keyof typeof ROUTE_AVOID_IDS] || null;

  if (Number.isFinite(id)) {
    acc.push(id);
  }

  return acc;
}, [] as number[]);
